



















































import {
  computed, defineComponent,
} from '@vue/composition-api';
import FCImage from '~/components/FCImage.vue';
import { shortTextWrap } from '~/components/storyblokDynamic/Thumbnail/helpers';
import { getAngieUIComponent } from '~/selectors/selectorsMap';
import { isMobileEffect } from '~/effects/matchMedia';
import { ITrainerThumbnailExpectedAttrs } from './types';
import { trainerThumbnailComponentsWhitelist } from './helpers';
import { activeSlideStore } from './activeSlide.store';

export default defineComponent({
  name: 'StoryblokTrainerThumbnail',
  components: {
    FCImage,
  },
  inheritAttrs: false,
  setup(_, context) {
    const isMobile = isMobileEffect();

    const {
      _uid: id,
      career,
      experience,
      focus,
      name: trainerName,
      profileImage,
    } = context.attrs as ITrainerThumbnailExpectedAttrs;

    const allowedComponents = computed((): {
      career?: any,
      experience?: any,
      focus?: any,
      name?: any,
      rotatedName?: any,
    } => [
      {
        name: 'career',
        data: shortTextWrap({ text: career }),
      },
      {
        name: 'experience',
        data: shortTextWrap({ text: experience }),
      },
      {
        name: 'focus',
        data: shortTextWrap({ text: focus }),
      },
      {
        name: 'name',
        data: shortTextWrap({
          text: trainerName,
          textColor: 'red',
          textTheme: 'heading-2',
          paddingTop: 'fc-padding-top-5',
          paddingBottom: 'fc-padding-bottom-4',
        }),
      },
      {
        name: 'rotatedName',
        data: shortTextWrap({
          text: trainerName,
          textColor: 'red',
          textTheme: 'heading-2',
          textAlignment: 'fc-text-right',
        }),
      },
    ]
      .filter(({ data }) => (data.text ?? '').length && trainerThumbnailComponentsWhitelist.has(data?.component))
      .reduce((acc, { data, name }) => ({ ...acc, [name]: data }), { }));

    return {
      isActiveSlide: computed(() => isMobile.value || activeSlideStore.isActiveSlide(id)),
      handleClick() {
        activeSlideStore.setActiveSlide(id);
      },
      validThumbnail: computed(() => Object.values(allowedComponents.value).length > 0),
      profileImage,
      careerProps: computed(() => getAngieUIComponent('ShortText', allowedComponents.value?.career)),
      experienceProps: computed(() => getAngieUIComponent('ShortText', allowedComponents.value?.experience)),
      focusProps: computed(() => getAngieUIComponent('ShortText', allowedComponents.value?.focus)),
      nameProps: computed(() => getAngieUIComponent('ShortText', allowedComponents.value?.name)),
      rotatedNameProps: computed(() => getAngieUIComponent('ShortText', allowedComponents.value?.rotatedName)),
    };
  },
});
